import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Dictionary } from '@ngrx/entity';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { combineLatest, merge, Observable, ReplaySubject } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    distinctUntilKeyChanged,
    filter,
    map,
    startWith,
    switchMap,
    take,
    takeWhile,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import * as fromSettings from '../../company-setting';
import * as fromDataServices from '../../data-services';
import * as fromLookups from '../../lookups';
import { IDirectReport, IUserGroup } from '../../lookups';
import * as fromPayroll from '../../payroll/item';
import * as fromShared from '../../shared';
import { getDynamicColumns, Guid } from '../../shared';
import { DialogService, SelectItem } from '../../shared/efaact-primeng.module';
import { IShowErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';
import * as fromUserRole from '../../user-role';
import { ProjectBudgetAddContainerComponent } from '../project-budget-add-container/project-budget-add-container.component';
import * as XLSX from 'xlsx';
import * as fromActions from '../store/budget-upload.actions';
import { ReportParams } from '../../reporting/store/report-params.model';
import * as fromReports from '../../reporting/store';
import * as fromAuth from '../../auth/store/auth.reducer';
import { ProjectBudgetService } from '../project-budget.service';
@Component({
    selector: 'ef-project-budget-container',
    templateUrl: './project-budget-container.component.html',
    styleUrls: ['./project-budget-container.component.scss'],
    standalone: false
})
export class ProjectBudgetContainerComponent implements OnInit, OnDestroy {
    projectBudgetDataService: EntityCollectionService<fromDataServices.ProjectBudget.ProjectBudget>;
    contractSummaryDataService: EntityCollectionService<fromDataServices.Contract.Summary.ContractSummary>;
    budgetLevelDataService: EntityCollectionService<fromDataServices.BudgetLevel.BudgetLevel>;
    budgetCycleDataService: EntityCollectionService<fromDataServices.BudgetCycle.BudgetCycle>;
    ShowAddBudgetSubject = new ReplaySubject(1);
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    selectContractSubject =
        new ReplaySubject<fromDataServices.Contract.Summary.ContractSummary>(1);
    saveSummarySubject =
        new ReplaySubject<fromDataServices.Contract.Summary.ContractSummary>(1);
    DownloadContractSubject = new ReplaySubject(1);
    DownloadBudgetSubject = new ReplaySubject(1);
    GetScheduleDatesSubject = new ReplaySubject(1);
    JumpstartSubject = new ReplaySubject(1);
    JumpstartSuccessSubject = new ReplaySubject(1);
    SaveBudgetMetadataSubject =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    AddBudgetSubject =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    SaveBudgetSubject =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    DeleteBudgetSubject =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    UpdateBudgetSubject = new ReplaySubject<any>(1);
    selectedError$: Observable<IShowErrors>;
    projectBudgets$: Observable<fromDataServices.ProjectBudget.ProjectBudget[]>;
    contractFilterSelectItems$: Observable<SelectItem[]>;
    budgetLevels$: Observable<SelectItem[]>;
    budgetCycles$: Observable<SelectItem[]>;
    fiscalYearsSelectItems$: Observable<SelectItem[]>;
    process$: Observable<fromShared.Process>;
    contracts$: Observable<fromDataServices.Contract.Summary.ContractSummary[]>;
    userInfo$: Observable<fromUser.IUserInfo>;
    roles$: Observable<fromUserRole.IUserRole[]>;
    costCenters$: Observable<IUserGroup[]>;
    FYEndDate$: Observable<Date>;
    FYStartDate$: Observable<Date>;
    allowCost$: Observable<boolean>;
    public directReports$: Observable<SelectItem[]>;
    public serviceItems$: Observable<SelectItem[]>;
    public payrollItems$: Observable<SelectItem[]>;
    autoCalculateAmount$: Observable<boolean>;
    FYEndDateSubject = new ReplaySubject<Date>(1);
    BudgetCycleChangeSubject = new ReplaySubject<string>(1);
    FiscalYearChangeSubject = new ReplaySubject<Date[]>(1);
    addDialogRef: fromShared.DynamicDialogRef;
    active = true;
    editingContract = false;
    editingBudget = false;
    public tabHeight = '';

    showUploadDialog = false;
    showUploadError = false;
    excelFileAsJsonStr: string;
    excelFileAsJson: any;
    budgetUpload = false;
    budgetUploadDate: any;
    @Output() uploadJSON = new ReplaySubject(1);
    @ViewChild('fileUpload') uploadInput: ElementRef;
    uploadSuccessMessage: string;
    tableScrollHeight = '50vh';
    detailTableScrollHeight = '60vh';
    detailDivScrollHeight = '70vh';
    divScrollHeight = '60vh';

    public reports$: Observable<Array<fromReports.Report>>;
    private auth$: Observable<fromAuth.State>;

    private RunReportsSubject = new ReplaySubject<{
        reports: Array<fromReports.Report>;
        queryparams: any;
        params: ReportParams;
    }>(1);

    reports: fromReports.Report[];

    constructor(
        public entityServices: EntityServices,
        private store: Store,
        public dialogService: DialogService,
        private log: LoggingService,
        private service: ProjectBudgetService,
        private cdRef: ChangeDetectorRef
    ) {
        this.projectBudgetDataService =
            entityServices.getEntityCollectionService<fromDataServices.ProjectBudget.ProjectBudget>(
                fromDataServices.ProjectBudget.entityName
            );
        this.contractSummaryDataService =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Summary.ContractSummary>(
                fromDataServices.Contract.Summary.entityName
            );
        this.budgetLevelDataService =
            entityServices.getEntityCollectionService<fromDataServices.BudgetLevel.BudgetLevel>(
                fromDataServices.BudgetLevel.entityName
            );
        this.budgetCycleDataService =
            entityServices.getEntityCollectionService<fromDataServices.BudgetCycle.BudgetCycle>(
                fromDataServices.BudgetCycle.entityName
            );
    }
    ngOnInit(): void {
        this.contractSummaryDataService.clearCache();
        this.budgetLevelDataService.clearCache();
        this.budgetCycleDataService.clearCache();
        this.projectBudgetDataService.clearCache();

        this.setupObservables();
        this.setupSubscriptions();
        setTimeout(() => {
            this.contractSummaryDataService.getAll();
            this.budgetLevelDataService.getAll();
            this.budgetCycleDataService.getAll();
            this.store.dispatch(
                fromSettings.getCompanySetting({ SettingType: 'PMAllowCost' })
            );
            this.store.dispatch(
                fromSettings.getCompanySetting({
                    SettingType: 'BudgetAutoCalc'
                })
            );
            this.GetScheduleDatesSubject.next();

            this.handleOnOpen([0, 1]);
        }, 0);
    }
    ngOnDestroy(): void {
        this.active = false;
        if (this.addDialogRef) {
            this.addDialogRef.close();
        }
    }

    openBudgetReport() {
        const data = {
            reports: this.reports,
            queryparams: {
                StartDate: moment(new Date()).isValid()
                    ? moment(new Date()).format('YYYY-MM-DD')
                    : null,
                EndDate: moment(new Date()).isValid()
                    ? moment(new Date()).format('YYYY-MM-DD')
                    : moment(new Date()).isValid()
                    ? moment(new Date()).format('YYYY-MM-DD')
                    : null
            },
            params: {
                DirectReportList: [],
                ContractList: []
            }
        };
        // TODO: check if API wants this to be null or non-existent
        if (!data.queryparams.StartDate) {
            delete data.queryparams.StartDate;
        }
        this.onRunReports(data);
    }

    onRunReports(data) {
        this.RunReportsSubject.next(data);
    }

    openUploadDialog() {
        this.showUploadDialog = true;
    }

    uploadExcelFile($event) {
        this.showUploadError = false;
        this.fileToString($event.target.files[0]);
    }

    fileToString(file) {
        const fileNameSpan = document.getElementById('file-selected');
        fileNameSpan.textContent = file.name;

        const reader = new FileReader();
        reader.onload = event => {
            const binaryData = event.target.result;
            this.excelToJSON(binaryData);
        };
        reader.readAsBinaryString(file);
    }

    excelToJSON(binaryData) {
        const workbook = XLSX.read(binaryData, { type: 'binary' });

        const jsonData = workbook.SheetNames.reduce((initial, name) => {
            const sheet = workbook.Sheets[name];
            initial = XLSX.utils.sheet_to_json(sheet);
            return initial;
        }, {});

        this.excelFileAsJson = jsonData;
        //this.excelFileAsJsonStr = JSON.stringify(jsonData);
        //console.log(this.excelFileAsJsonStr);
    }

    sendJSON() {
        if (this.excelFileAsJson != null) {
            this.budgetUpload = true;
            this.excelFileAsJson = this.excelFileAsJson.map(x => ({
                ...x,
                StartDate: moment(this.dateToISODateString(x.StartDate)).format(
                    'MM/DD/YY'
                ),
                EndDate: moment(this.dateToISODateString(x.EndDate)).format(
                    'MM/DD/YY'
                )
            }));
            //this.budgetUploadDate = this.excelFileAsJson[0].PeriodEndDate;
            this.excelFileAsJsonStr = JSON.stringify(this.excelFileAsJson);
            this.onUploadJSON(this.excelFileAsJsonStr);
            //this.uploadJSON.next(this.excelFileAsJsonStr);
            this.reset();
        } else {
            this.showUploadError = true;
            this.budgetUpload = false;
        }
    }

    onUploadJSON($event) {
        this.store.dispatch(fromActions.uploadBudgets({ JsonString: $event }));
        //this.cumulativeUploadDataService.getWithQuery({JsonString: $event});
    }

    cancelUpload() {
        this.showUploadError = false;
        this.reset();
    }
    reset() {
        this.showUploadError = false;
        this.showUploadDialog = false;
        this.excelFileAsJsonStr = null;
        this.uploadInput.nativeElement.value = '';
        const fileNameSpan = document.getElementById('file-selected');
        fileNameSpan.textContent = '';
        setTimeout(() => {
            this.uploadSuccessMessage = localStorage.getItem('uploadMessage');
        }, 1000);
        setTimeout(() => {
            this.uploadSuccessMessage = null;
            localStorage.removeItem('uploadMessage');
        }, 20000);
    }
    dateToISODateString(excelDate) {
        return this.excelDateConversion(excelDate).toISOString(); //.split('T')[0];
    }
    excelDateConversion(excelDate) {
        return new Date(Date.UTC(0, 0, excelDate));
    }

    setupObservables(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.auth$ = this.store.pipe(select(fromAuth.getAuth));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors)
        );
        this.reports$ = this.store.pipe(
            select(fromReports.selectAll),
            map(x => clone(x))
        );
        this.roles$ = this.store.pipe(select(fromUserRole.getUserRoles));
        this.allowCost$ = this.store.pipe(
            select(fromSettings.selectEntities),
            map(
                (x: Dictionary<fromSettings.CompanySetting>) =>
                    x['PMAllowCost'] &&
                    (x['PMAllowCost'].SettingValue === true ||
                        x.PMAllowCost.SettingValue === 'true' ||
                        x['PMAllowCost'].SettingValue === '1')
            )
        );
        this.FYEndDate$ = this.userInfo$.pipe(
            filter(x => !!x),
            map(x => x.FYEndDate)
        );
        this.FYStartDate$ = this.userInfo$.pipe(
            filter(x => !!x),
            map(x => x.FYStartDate)
        );
        this.FYEndDate$ = this.userInfo$.pipe(
            filter(x => !!x),
            map(x => x.FYEndDate)
        );
        this.contracts$ = this.contractSummaryDataService.entities$.pipe(
            map(items => clone(items))
        );
        this.budgetLevels$ = this.budgetLevelDataService.entities$.pipe(
            map(items =>
                items.map(item => ({
                    label: item.Budgetlevel,
                    value: item.Budgetlevelid
                }))
            )
        );
        this.budgetCycles$ = this.budgetCycleDataService.entities$.pipe(
            map(items =>
                items.map(item => ({
                    label: item.Budgetcycle,
                    value: item.Budgetcycleid
                }))
            )
        );
        this.directReports$ = this.store.pipe(
            select(fromLookups.getDirectReportsLookup),
            map(items =>
                items.map(item => ({
                    label: item.EmployeeName,
                    value: item.EmployeeListID
                }))
            )
        );
        this.serviceItems$ = this.store.pipe(
            select(fromLookups.getServiceItemsLookup),
            map(items =>
                items.map(item => ({
                    label: item.ServiceItem,
                    value: item.SIListID
                }))
            )
        );
        this.payrollItems$ = this.store.pipe(
            select(fromLookups.getPayrollItemsLookup),
            map(items =>
                items.map(item => ({
                    label: item.PayrollItem,
                    value: item.PIListID
                }))
            )
        );

        this.projectBudgets$ = this.projectBudgetDataService.entities$.pipe(
            withLatestFrom(
                this.selectContractSubject.pipe(
                    filter(x => !!x && !!x.Contractlistid),
                    distinctUntilKeyChanged('Contractlistid')
                )
            ),
            tap(x =>
                this.log.verbose({
                    type: 'ProjectBudgetContainerComponent:projectBudgets$,selectContractSubject',
                    x
                })
            ),
            map(([items, pb]) =>
                clone(items).map(item => ({
                    ...item,
                    Contractlistid: pb.ContractListID
                }))
            )
        );
        this.contractFilterSelectItems$ = this.contracts$.pipe(
            takeWhile(() => this.active),
            map(items =>
                items.map(x => ({
                    label: x.Contractdesc,
                    value: x.Contractdesc
                }))
            ),
            map(items => fromShared.uniqBy(items, x => x.value))
        );
        this.autoCalculateAmount$ = this.store.pipe(
            select(fromSettings.getSettingBooleanValue('BudgetAutoCalc'))
        );
        combineLatest([this.userInfo$, this.process$])
            .pipe(take(1))
            .subscribe(([userInfo, process]) => {
                this.store.dispatch(
                    new fromLookups.LoadDirectReports({
                        user: userInfo,
                        activeOnly: true,
                        processId: process.ProcessID
                    })
                );
            });
    }
    setupSubscriptions(): void {
        this.reports$.pipe(takeWhile(() => this.active)).subscribe(reports => {
            this.reports = reports;
        });

        this.RunReportsSubject.pipe(withLatestFrom(this.auth$, this.userInfo$))
            .pipe(takeWhile(x => this.active))
            .subscribe(([{ reports, queryparams, params }, auth, userInfo]) => {
                const report = reports.find(x => x.RptNbr == 907);

                this.store.dispatch(
                    fromReports.runReport({
                        report: {
                            report,
                            params: {
                                ...params,
                                EmployeeListID: userInfo.EmployeeListID,
                                RptID: report.RptID
                            },
                            queryparams: {
                                ...queryparams,
                                User: userInfo.EmployeeListID,
                                Cust: auth.CustomerID,
                                GroupId: -1
                            }
                        }
                    })
                );
            });

        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        this.JumpstartSuccessSubject.pipe(
            takeWhile(() => this.active),
            startWith({}),
            withLatestFrom(
                this.selectContractSubject,
                this.FiscalYearChangeSubject,
                this.projectBudgets$
            ),
            tap(x =>
                this.log.verbose({
                    type: 'ProjectBudgetContainerComponent:JumpstartSuccessSubject:JumpstartSuccessSubject:raw',
                    x
                })
            )
        ).subscribe(([, contract, budgetDates, budgets]) => {
            this.log.verbose({
                type: 'ProjectBudgetContainerComponent:JumpstartSuccessSubject:JumpstartSuccessSubject',
                contract,
                budgetDates
            });
            this.projectBudgetDataService.removeOneFromCache({
                id: 'jumpstart'
            } as fromDataServices.ProjectBudget.ProjectBudget);
            const contractBudgets =
                this.projectBudgetDataService.removeManyFromCache(
                    budgets.filter(
                        x => x.Contractlistid === contract.ContractListID
                    )
                );
            // const sd = dates.find(d => moment(d.ScheduledEndDate).isSame(fy));
            // this.FYEndDateSubject.next(moment(fyEndDate).toDate());
            this.projectBudgetDataService.getWithQuery({
                ContractListID: contract.Contractlistid,
                BudgetStartDate: moment(budgetDates[0]).isValid()
                    ? moment(budgetDates[0]).format('MM/DD/YYYY')
                    : null,
                BudgetEndDate: moment(budgetDates[1]).isValid()
                    ? moment(budgetDates[1]).format('MM/DD/YYYY')
                    : null
            });
        });
        const fySelected = merge(
            this.FiscalYearChangeSubject.pipe(
                takeWhile(() => this.active),
                tap(items =>
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:FiscalYearChangeSubject',
                        items
                    })
                ),
                tap(([startDate, endDate]) =>
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:FiscalYearChangeSubject',
                        startDate,
                        endDate
                    })
                ),
                filter(([startDate, endDate]) => !!startDate && !!endDate),
                tap(items =>
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:FiscalYearChangeSubject',
                        items
                    })
                )
            )
        ).pipe(
            takeWhile(() => this.active),
            tap(items =>
                this.log.verbose({
                    type: 'ProjectBudgetContainerComponent:fySelected',
                    items
                })
            )
        );
        this.saveSummarySubject
            .pipe(takeWhile(() => this.active))
            .subscribe(contract => {
                this.GetScheduleDatesSubject.next();
                this.contractSummaryDataService.update(contract);
            });
        combineLatest([
            merge(
                this.selectContractSubject.pipe(
                    tap(contract =>
                        this.log.verbose({
                            type: 'ProjectBudgetContainerComponent:combineLatest:selectContractSubject',
                            contract
                        })
                    ),
                    filter(x => !!x && !!x.Contractlistid),
                    distinctUntilKeyChanged('Contractlistid')
                ),
                this.saveSummarySubject
            ),
            fySelected.pipe(
                tap(fy =>
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:combineLatest:fySelected',
                        fy
                    })
                ),
                distinctUntilChanged()
            )
        ])
            .pipe(
                takeWhile(() => this.active),
                debounceTime(100),
                tap(items =>
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:combineLatest((select/save)ContractSubject, fiscalYears, fySelected)',
                        items
                    })
                )
            )
            .subscribe(([contract, budgetDates]) => {
                this.log.verbose({
                    type: 'ProjectBudgetContainerComponent:combineLatest(selectContractSubject, fiscalYears, fySelected):fiscalYears',
                    contract,
                    budgetDates
                });
                this.projectBudgetDataService.clearCache();
                this.projectBudgetDataService.getWithQuery({
                    ContractListID: contract.Contractlistid,
                    BudgetStartDate: moment(budgetDates[0]).isValid()
                        ? moment(budgetDates[0]).format('MM/DD/YYYY')
                        : null,
                    BudgetEndDate: moment(budgetDates[1]).isValid()
                        ? moment(budgetDates[1]).format('MM/DD/YYYY')
                        : null
                });
                this.cdRef.detectChanges();
            });
        this.AddBudgetSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(
                this.selectContractSubject,
                fySelected.pipe(distinctUntilChanged())
            )
        ).subscribe(([budget, contract, budgetDates]) => {
            const disburseHours = Number(budget.DisburseHours) || 0;
            const disburseAmount = Number(budget.DisburseAmount) || 0;
            const item = {
                TaskListID: this.optionValue(budget.TaskListID),
                CostType: this.optionValue(budget.CostType),
                SIListID: this.optionValue(budget.SIListID),
                PIListID: this.optionValue(budget.PIListID),
                CostCenterID: this.optionValue(budget.CostCenterID),
                PersonListID: this.optionValue(budget.PersonListID)
            };
            this.log.info({
                type: 'ProjectBudgetContainerComponent:AddBudget',
                item,
                budget,
                disburseHours,
                disburseAmount,
                budgetDates
            });
            this.service
                .createAndDisburse({
                    item,
                    contractListId: contract.Contractlistid,
                    budgetStartDate: moment(budgetDates[0]).isValid()
                        ? moment(budgetDates[0]).format('MM/DD/YYYY')
                        : null,
                    budgetEndDate: moment(budgetDates[1]).isValid()
                        ? moment(budgetDates[1]).format('MM/DD/YYYY')
                        : null,
                    disburseHours,
                    disburseAmount
                })
                .pipe(take(1))
                .subscribe({
                    next: () => {
                        this.projectBudgetDataService.clearCache();
                        this.loadProjectBudgets(contract, budgetDates);
                        this.contractSummaryDataService.getAll();
                    },
                    error: error => {
                        this.log.error({
                            type: 'ProjectBudgetContainerComponent:AddBudget:error',
                            error
                        });
                        this.projectBudgetDataService.clearCache();
                        this.loadProjectBudgets(contract, budgetDates);
                    }
                });
        });
        this.SaveBudgetSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(
                this.selectContractSubject,
                fySelected.pipe(distinctUntilChanged())
            )
        ).subscribe(([budget, contract, budgetDates]) => {
            this.log.verbose({
                type: 'ProjectBudgetContainerComponent:onSaveBudget$',
                contract,
                budget,
                budgetDates
            });
            this.projectBudgetDataService
                .update({
                    ...budget,
                    Contractlistid: contract.Contractlistid,
                    BudgetStartDate: budgetDates[0],
                    BudgetEndDate: budgetDates[1],
                    DeleteBudget: true
                } as any)
                .pipe(take(1))
                .subscribe(resp => {
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:onSaveBudget$',
                        resp
                    });
                    this.projectBudgetDataService.clearCache();
                    this.projectBudgetDataService.getWithQuery({
                        ContractListID: contract.Contractlistid,
                        BudgetStartDate: moment(budgetDates[0]).isValid()
                            ? moment(budgetDates[0]).format('MM/DD/YYYY')
                            : null,
                        BudgetEndDate: moment(budgetDates[1]).isValid()
                            ? moment(budgetDates[1]).format('MM/DD/YYYY')
                            : null
                    });
                    // this.contractSummaryDataService.getAll();
                    this.contractSummaryDataService.getAll();
                });
        });
        this.DeleteBudgetSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(
                this.selectContractSubject,
                fySelected.pipe(distinctUntilChanged())
            )
        ).subscribe(([budget, contract, budgetDates]) => {
            this.log.verbose({
                type: 'ProjectBudgetContainerComponent:onDeleteBudget$',
                contract,
                budget,
                budgetDates
            });
            this.service
                .delete(budget, budgetDates[0], budgetDates[1])
                .pipe(take(1))
                .subscribe(resp => {
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:onDeleteBudget$',
                        resp
                    });
                    this.projectBudgetDataService.clearCache();
                    this.projectBudgetDataService.getWithQuery({
                        ContractListID: contract.Contractlistid,
                        BudgetStartDate: moment(budgetDates[0]).isValid()
                            ? moment(budgetDates[0]).format('MM/DD/YYYY')
                            : '',
                        BudgetEndDate: moment(budgetDates[1]).isValid()
                            ? moment(budgetDates[1]).format('MM/DD/YYYY')
                            : ''
                    });
                    this.contractSummaryDataService.getAll();
                });
        });
        this.SaveBudgetMetadataSubject.pipe(
            withLatestFrom(
                this.selectContractSubject,
                fySelected.pipe(distinctUntilChanged())
            )
        ).subscribe(([budget, contract, budgetDates]) => {
            this.log.verbose({
                type: 'ProjectBudgetContainerComponent:SaveBudgetMetadataSubject',
                budget,
                contract,
                budgetDates
            });
            this.projectBudgetDataService
                .update({
                    ...budget,
                    BudgetStartDate: moment(budgetDates[0]).isValid()
                        ? (moment(budgetDates[0]).format('MM/DD/YYYY') as any)
                        : null,
                    BudgetEndDate: moment(budgetDates[1]).isValid()
                        ? (moment(budgetDates[1]).format('MM/DD/YYYY') as any)
                        : null
                })
                .pipe(take(1))
                .subscribe(() => {
                    this.projectBudgetDataService.clearCache();
                    this.projectBudgetDataService.getWithQuery({
                        ContractListID: contract.Contractlistid,
                        BudgetStartDate: moment(budgetDates[0]).isValid()
                            ? moment(budgetDates[0]).format('MM/DD/YYYY')
                            : null,
                        BudgetEndDate: moment(budgetDates[1]).isValid()
                            ? moment(budgetDates[1]).format('MM/DD/YYYY')
                            : null
                    });
                    this.contractSummaryDataService.getAll();
                });
        });
        this.JumpstartSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(
                this.selectContractSubject,
                this.FiscalYearChangeSubject
            )
        ).subscribe(([, contract, budgetDates]) => {
            this.projectBudgetDataService
                .add({
                    ContractListID: contract.Contractlistid,
                    JumpStart: true,
                    BudgetEndDate: budgetDates[1],
                    id: 'jumpstart'
                } as unknown as fromDataServices.ProjectBudget.ProjectBudget)
                // .pipe(take(1))
                .subscribe(() => {
                    this.JumpstartSuccessSubject.next();
                });
        });
        this.UpdateBudgetSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(
                this.selectContractSubject,
                fySelected.pipe(distinctUntilChanged())
            )
        ).subscribe({
            next: ([updateData, contract, budgetDates]) => {
                this.saveBudgetPeriodUpdate(updateData, contract, budgetDates);
            },
            error: error => {
                this.log.error({
                    type: 'ProjectBudgetContainerComponent:UpdateBudgetSubject:subscribeError',
                    error
                });
            }
        });
        this.ShowAddBudgetSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(this.selectContractSubject)
        ).subscribe(([, contract]) => {
            this.addDialogRef = this.dialogService.open(
                ProjectBudgetAddContainerComponent,
                {
                    // header: 'Add Project Budget',
                    // closable: false,
                    // closeOnEscape: false,
                    // showHeader: false,
                    // modal: true
                    data: {
                        contract
                        // ContractListID: contract.Contractlistid
                    }
                }
            );
            this.addDialogRef.onClose
                .pipe(
                    take(1),
                    filter(x => !!x)
                )
                .subscribe(data => {
                    this.log.verbose({
                        type: 'ProjectBudgetContainerComponent:afterClosed',
                        data
                    });
                    this.AddBudgetSubject.next(data);
                });
        });
        this.GetScheduleDatesSubject.pipe(
            takeWhile(() => this.active),
            debounceTime(100)
        ).subscribe(() => {
            this.store.dispatch(
                fromLookups.ScheduledDateActions.getScheduledDates({
                    ShowAll: true
                })
            );
        });
        this.costCenters$ = this.store.pipe(select(fromLookups.getCostCenters));
    }
    onBudgetCycleChange($event) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onBudgetCycleChange',
            $event
        });
        this.BudgetCycleChangeSubject.next($event);
    }
    onSelectContract(
        $event: fromDataServices.Contract.Summary.ContractSummary
    ) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onSelectContract',
            $event
        });
        this.selectContractSubject.next($event);
    }
    onFiscalYearChange($event) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onFiscalYearChange',
            $event
        });
        this.FiscalYearChangeSubject.next($event);
    }
    onSaveBudget($event: fromDataServices.ProjectBudget.ProjectBudget) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onSaveBudget',
            $event
        });
        // this.projectBudgetDataService.update($event);
        this.SaveBudgetSubject.next($event);
    }
    onSaveMetadata($event: fromDataServices.ProjectBudget.ProjectBudget) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onSaveMetadata',
            $event
        });
        this.SaveBudgetMetadataSubject.next($event);
    }
    onSelectPerson(personListID: string) {
        //load payroll items for this person
        this.store.dispatch(new fromLookups.LoadPayrollItems([personListID]));
    }
    // onDeleteBudget($event: fromDataServices.ProjectBudget.ProjectBudget) {
    //     this.log.verbose({
    //         type: 'ProjectBudgetContainerComponent:onDeleteBudget',
    //         $event
    //     });
    //     this.SaveBudgetSubject.next($event);
    // }
    onDeleteBudget($event: fromDataServices.ProjectBudget.ProjectBudget) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onDeleteBudget',
            $event
        });
        if ($event) {
            // this.SaveBudgetSubject.next({
            //     TxnID: $event[0].TxnID,
            //     BudgetStartDate: $event.BudgetStartDate,
            //     BudgetEndDate: $event.BudgetEndDate
            // } as unknown as fromDataServices.ProjectBudget.ProjectBudget);
            // debugger;
            this.DeleteBudgetSubject.next($event);
        }
    }
    onUpdateBudget($event: any) {
        if (!$event) {
            return;
        }
        this.UpdateBudgetSubject.next($event);
    }
    onSaveBudgetContract(
        $event: fromDataServices.Contract.Summary.ContractSummary
    ) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onSaveBudgetContract',
            $event
        });
        this.saveSummarySubject.next($event);
    }
    onAddBudget($event) {
        this.ShowAddBudgetSubject.next();
    }
    onJumpstart() {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:afterClosed'
        });
        this.JumpstartSubject.next();
    }
    public onDownload(type) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onDownload',
            value: type
        });
        if (type === 'budget') {
            this.DownloadBudgetSubject.next(Guid.newGuid());
        }
        if (type === 'contract') {
            this.DownloadContractSubject.next(Guid.newGuid());
        }
    }
    public onShowError($event) {
        this.ShowErrorSubject.next($event);
    }
    handleOnOpen($event) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:handleOnOpen',
            $event
        });
        const baseHeight = 45;
        const divBaseHeight = 45;
        const detailBaseHeight = 50;
        const detailDivBaseHeight = 60;

        this.tableScrollHeight = `${
            baseHeight / ($event && $event.length ? $event.length : 1)
        }vh`;
        this.detailTableScrollHeight = `${
            detailBaseHeight / ($event && $event.length ? $event.length : 1)
        }vh`;
        this.divScrollHeight = `${
            divBaseHeight / ($event && $event.length ? $event.length : 1)
        }vh`;
        this.detailDivScrollHeight = `${
            detailDivBaseHeight / ($event && $event.length ? $event.length : 1)
        }vh`;
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }
    onEditBudgetInit($event) {
        this.editingBudget = $event;
        // this.store.dispatch(
        //     new fromLookups.LoadPayrollItems([$event.PersonListID])
        // );
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onEditBudgetInit',
            $event
        });
        this.payrollItems$ = this.store.pipe(
            select(fromLookups.getPayrollItemsLookup),
            map(items =>
                items
                    .filter(item => item.IsActive)
                    .filter(p => p.EmployeeListID === $event.PersonListID)
            ),
            map(items =>
                items.map(item => ({
                    label: item.PayrollItem,
                    value: item.PIListID
                }))
            )
        );
    }
    onEditBudgetCancel($event) {
        this.log.verbose({
            type: 'ProjectBudgetContainerComponent:onEditBudgetCancel',
            $event
        });
        this.editingBudget = false;
        this.payrollItems$ = this.store.pipe(
            select(fromLookups.getPayrollItemsLookup),
            map(items => items.filter(item => item.IsActive)),
            map(items =>
                items.map(item => ({
                    label: item.PayrollItem,
                    value: item.PIListID
                }))
            )
        );
    }
    private loadProjectBudgets(
        contract: fromDataServices.Contract.Summary.ContractSummary,
        budgetDates: Date[]
    ) {
        return this.projectBudgetDataService.getWithQuery({
            ContractListID: contract.Contractlistid,
            BudgetStartDate: moment(budgetDates[0]).isValid()
                ? moment(budgetDates[0]).format('MM/DD/YYYY')
                : null,
            BudgetEndDate: moment(budgetDates[1]).isValid()
                ? moment(budgetDates[1]).format('MM/DD/YYYY')
                : null
        });
    }
    private saveBudgetPeriodUpdate(
        updateData: any,
        contract: fromDataServices.Contract.Summary.ContractSummary,
        budgetDates: Date[]
    ): void {
        if (!updateData || !contract || !budgetDates) {
            return;
        }

        const allPeriodColumns = getDynamicColumns(
            updateData,
            this.service.filterItems
        );

        const budgetUpdate: any = {
            id: updateData.id,
            TxnID: updateData.TxnID,
            Hours: String(updateData.Hours || 0),
            Amount: String(updateData.Amount || 0),
            ActualHours: null,
            Variance: null,
            ForecastHours: null,
            ActualAmount: null,
            VarianceAmount: null,
            ForecastAmount: null,
            AutoCalculateAmount: updateData.AutoCalculateAmount,
            CostType: updateData.CostType,
            ContractDesc: updateData.ContractDesc,
            TaskListID: updateData.TaskListID,
            TaskLongName: updateData.TaskLongName,
            PersonListID: updateData.PersonListID,
            PersonName: updateData.PersonName,
            SIListID: updateData.SIListID,
            ServiceItem: updateData.ServiceItem,
            PIListID: updateData.PIListID,
            PayrollItem: updateData.PayrollItem,
            CostCenterID: updateData.CostCenterID,
            CostCenterDesc: updateData.CostCenterDesc,
            ContractType: updateData.ContractType,
            Contractlistid: contract.Contractlistid,
            YearlyBudgetAmount: 0,
            YearlyBudgetHours: 0,
            BudgetStartDate: budgetDates[0],
            BudgetEndDate: budgetDates[1],
            DeleteBudget: true,
            JumpStart: false,
            Status: {
                StatusCode: 99,
                Message: 'Saving'
            }
        };

        let firstPeriodTxnID = null;

        if (
            updateData.Periods &&
            Array.isArray(updateData.Periods) &&
            updateData.Periods.length > 0
        ) {
            updateData.Periods.forEach((selectedTxnID: any) => {
                const txnID = this.periodTxnId(selectedTxnID);
                if (!txnID) {
                    return;
                }

                let periodField: string | null = null;
                for (const periodCol of allPeriodColumns) {
                    const periodData = updateData[periodCol];
                    if (
                        periodData &&
                        typeof periodData === 'object' &&
                        this.periodTxnId(periodData.TxnID) === txnID
                    ) {
                        periodField = periodCol;
                        break;
                    }
                }

                if (periodField) {
                    const existingPeriodData = updateData[periodField];

                    if (
                        existingPeriodData &&
                        typeof existingPeriodData === 'object' &&
                        existingPeriodData.TxnID
                    ) {
                        if (!firstPeriodTxnID) {
                            firstPeriodTxnID = existingPeriodData.TxnID;
                        }
                        budgetUpdate[periodField] = {
                            TxnID: existingPeriodData.TxnID,
                            Hours: String(updateData.Hours || 0),
                            Amount: String(updateData.Amount || 0)
                        };
                    }
                }
            });
        }

        if (firstPeriodTxnID) {
            budgetUpdate.TxnID = firstPeriodTxnID;
        }

        allPeriodColumns.forEach((periodCol: string) => {
            const periodData = updateData[periodCol];
            const periodTxnID =
                periodData && typeof periodData === 'object'
                    ? this.periodTxnId(periodData.TxnID)
                    : null;

            const isSelected =
                periodTxnID &&
                updateData.Periods &&
                updateData.Periods.some(
                    (selectedTxnID: any) =>
                        this.periodTxnId(selectedTxnID) === periodTxnID
                );

            if (!isSelected && budgetUpdate[periodCol]) {
                delete budgetUpdate[periodCol];
            }
        });

        delete budgetUpdate.Periods;

        this.projectBudgetDataService
            .update(budgetUpdate)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.projectBudgetDataService.clearCache();
                    this.loadProjectBudgets(contract, budgetDates);
                    this.contractSummaryDataService.getAll();
                },
                error: error => {
                    this.log.error({
                        type: 'ProjectBudgetContainerComponent:onUpdateBudget$:error',
                        error
                    });
                }
            });
    }
    private getPeriodTxnIds(
        item: fromDataServices.ProjectBudget.ProjectBudget
    ): number[] {
        return getDynamicColumns(item, this.service.filterItems)
            .map(col => this.periodTxnId(item[col]?.TxnID))
            .filter((txnId): txnId is number => !!txnId);
    }
    private periodTxnId(value: unknown): number | null {
        const unwrapped = this.optionValue(value);
        const parsed = Number(unwrapped);
        return Number.isFinite(parsed) && parsed !== 0 ? parsed : null;
    }
    private optionValue(value: unknown): unknown {
        if (
            value &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            'value' in (value as object)
        ) {
            return (value as { value: unknown }).value;
        }
        return value;
    }
    private findCreatedBudget(
        budgets: fromDataServices.ProjectBudget.ProjectBudget[],
        item: fromDataServices.ProjectBudget.ProjectBudget,
        existing: fromDataServices.ProjectBudget.ProjectBudget[] = []
    ): fromDataServices.ProjectBudget.ProjectBudget | undefined {
        const list = Array.isArray(budgets) ? budgets : [];
        const existingKeys = new Set(
            (existing || []).map(budget => this.budgetMatchKey(budget))
        );
        const identityMatches = list.filter(budget =>
            this.sameBudgetIdentity(budget, item)
        );
        const emptyIdentityMatches = identityMatches.filter(budget =>
            this.isEmptyBudget(budget)
        );
        if (emptyIdentityMatches.length) {
            return emptyIdentityMatches[emptyIdentityMatches.length - 1];
        }
        const newRows = list.filter(
            budget => !existingKeys.has(this.budgetMatchKey(budget))
        );
        const newEmptyRows = newRows.filter(budget =>
            this.isEmptyBudget(budget)
        );
        if (newEmptyRows.length) {
            return newEmptyRows[newEmptyRows.length - 1];
        }
        if (identityMatches.length) {
            return identityMatches[identityMatches.length - 1];
        }
        if (newRows.length) {
            return newRows[newRows.length - 1];
        }
        const looseMatches = list.filter(
            budget =>
                this.sameIdentityValue(budget.TaskListID, item.TaskListID) &&
                this.sameIdentityValue(budget.CostType, item.CostType)
        );
        return looseMatches[looseMatches.length - 1];
    }
    private budgetMatchKey(
        item: fromDataServices.ProjectBudget.ProjectBudget
    ): string {
        return [
            this.normalizeIdentityValue(item.TaskListID),
            this.normalizeIdentityValue(item.CostType),
            this.normalizeIdentityValue(item.SIListID),
            this.normalizeIdentityValue(item.PersonListID),
            this.normalizeIdentityValue(item.PIListID),
            Number(this.optionValue(item.CostCenterID)) || null
        ].join('|');
    }
    private sameBudgetIdentity(
        left: fromDataServices.ProjectBudget.ProjectBudget,
        right: fromDataServices.ProjectBudget.ProjectBudget
    ): boolean {
        return (
            this.sameIdentityValue(left.TaskListID, right.TaskListID) &&
            this.sameIdentityValue(left.CostType, right.CostType) &&
            this.sameIdentityValue(left.SIListID, right.SIListID) &&
            this.sameIdentityValue(left.PersonListID, right.PersonListID) &&
            this.sameIdentityValue(left.PIListID, right.PIListID) &&
            this.sameNumericIdentity(left.CostCenterID, right.CostCenterID)
        );
    }
    private sameIdentityValue(left: unknown, right: unknown): boolean {
        return (
            this.normalizeIdentityValue(left) ===
            this.normalizeIdentityValue(right)
        );
    }
    private sameNumericIdentity(left: unknown, right: unknown): boolean {
        const normalizedLeft = Number(this.optionValue(left)) || null;
        const normalizedRight = Number(this.optionValue(right)) || null;
        return normalizedLeft === normalizedRight;
    }
    private normalizeIdentityValue(value: unknown): string | null {
        const unwrapped = this.optionValue(value);
        if (
            unwrapped === null ||
            unwrapped === undefined ||
            unwrapped === ''
        ) {
            return null;
        }
        return String(unwrapped).toLowerCase();
    }
    private isEmptyBudget(
        item: fromDataServices.ProjectBudget.ProjectBudget
    ): boolean {
        const cols = getDynamicColumns(item, this.service.filterItems);
        return cols.every(
            col => !Number(item[col]?.Hours) && !Number(item[col]?.Amount)
        );
    }
}
